import { render, staticRenderFns } from "./ErrorBoundary.vue?vue&type=template&id=3aac2586&"
import script from "./ErrorBoundary.vue?vue&type=script&lang=ts&"
export * from "./ErrorBoundary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports